import React, { Component } from 'react'
import Button from '../../../common/CustomComponents/Button.js'
import Select from 'react-select'

class EditCruiseTripBooking extends Component {
    state = {
        type_tag: '',
        booking_status: '',
        selected_trip_id: '',
        total_booking_amount: '',
    }

    componentDidMount() {
        this.setState({
            type_tag: this.props.bookingDetails?.type_tag,
            booking_status: this.props.bookingDetails?.booking_status,
            selected_trip_id: this.props.bookingDetails?.trip?.id,
            total_booking_amount: this.props.bookingDetails?.total_amount,
        })
    }

    handleChange = (event) => {
        event.preventDefault()
        this.setState({ [event.target.name]: event.target.value })
    }

    handleTripChange = (selectedOption) => {
        this.setState({ selected_trip_id: selectedOption?.value })
    }

    render() {
        return (
            <div className="card">
                <div className="card-header">
                    <h5>Edit Booking Details</h5>
                </div>
                <div className="card-block">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group row">
                                <label className="col-sm-2 col-form-label">Type Tag</label>
                                <div className="col-sm-10">
                                    <select
                                        name="type_tag"
                                        className="form-control"
                                        value={this.state.type_tag}
                                        onChange={this.handleChange}
                                    >
                                        <option value="">Select Type Tag</option>
                                        <option value="NORMAL">NORMAL</option>
                                        <option value="FLASH">FLASH</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-2 col-form-label">Booking Status</label>
                                <div className="col-sm-10">
                                    <select
                                        name="booking_status"
                                        className="form-control"
                                        value={this.state.booking_status}
                                        onChange={this.handleChange}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Pending">Pending</option>
                                        <option value="Confirmed">Confirmed</option>
                                        <option value="Cancelled">Cancelled</option>
                                        <option value="Postponed">Postponed</option>
                                        <option value="Successful">Successful</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-2 col-form-label">Trip</label>
                                <div className="col-sm-10">
                                    <Select
                                        value={this.props.tripList.find((trip) => trip.value === this.state.selected_trip_id)}
                                        onChange={this.handleTripChange}
                                        options={this.props.tripList}
                                        isSearchable={true}
                                        placeholder="Select Trip"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-2 col-form-label">Total Amount</label>
                                <div className="col-sm-10">
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="total_booking_amount"
                                        placeholder="Total Amount"
                                        value={this.state.total_booking_amount}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <div className="row">
                        <div className="col-sm-12 text-right">
                            <Button
                                onClick={() => {
                                    this.props.editBookingCruise(this.state)
                                }}
                            >
                                Update
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default EditCruiseTripBooking 